import { noop } from '@tanstack/react-table';

const sdkHelper = {
  getAgentAvailability: () => false,
  setOnBreak: noop,
  setAvailable: noop,
  logoOut: noop
};

export default sdkHelper;
